module.exports = __webpack_public_path__ + "img/x16.a9dbb092.jpg";